/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import * as React from 'react';
import {
  ButtonWrapper,
  PrimaryButton,
  CancelButton,
  BackDeleteButton,
  HiddenButton,
  ResetButton,
} from './Button.styles';
import { ButtonProps } from './Button.types';

/**
 * @deprecated Use @ordermentum/ui-shared/components/Button instead
 */
export const Button = (props: ButtonProps) => {
  const {
    onClick,
    children,
    type = 'button',
    size = 'auto',
    height = 'normal',
    isInactive = false,
    id,
    dataTag,
    tabIndex,
    name,
    fontWeight = 'MEDIUM',
    title,
    fontSize = 'SM',
    borderRadius = '',
  } = props;
  const htmlProps: {
    disabled: boolean;
    type?: 'button' | 'reset' | 'submit';
    id?: string;
    tabIndex?: number;
    title?: string;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    name?: string;
    'data-tag': string;
    'data-testid'?: string;
  } = {
    disabled: isInactive,
    id,
    tabIndex,
    onClick,
    name,
    title,
    type: type === 'submit' || type === 'primary-submit' ? 'submit' : 'button',
    'data-tag': dataTag || `${type}-button`,
  };
  const buttonStyleProps = {
    size,
    height,
    borderRadius,
    fontSize,
    fontWeight,
  };

  switch (type) {
    case 'reset':
      return (
        <button
          {...htmlProps}
          css={[ButtonWrapper(buttonStyleProps), ResetButton]}
        >
          {children}
        </button>
      );

    case 'cancel':
      return (
        <button
          {...htmlProps}
          css={[ButtonWrapper(buttonStyleProps), CancelButton]}
        >
          {children}
        </button>
      );

    case 'back':
    case 'delete':
      return (
        <button
          {...htmlProps}
          css={[ButtonWrapper(buttonStyleProps), BackDeleteButton]}
        >
          {children}
        </button>
      );

    case 'hidden':
      return <button css={[HiddenButton]}>{children}</button>;

    case 'primary':
      return (
        <button
          {...htmlProps}
          css={[ButtonWrapper(buttonStyleProps), PrimaryButton]}
        >
          {children}
        </button>
      );

    case 'submit':
      return (
        <button {...htmlProps} css={[ButtonWrapper(buttonStyleProps)]}>
          {children}
        </button>
      );

    case 'primary-submit':
      return (
        <button
          {...htmlProps}
          css={[ButtonWrapper(buttonStyleProps), PrimaryButton]}
        >
          {children}
        </button>
      );

    case 'button':
    default:
      return (
        <button {...htmlProps} css={[ButtonWrapper(buttonStyleProps)]}>
          {children}
        </button>
      );
  }
};

export default Button;
